const strings = {
  START_TIME: 'Starttid',
  END_TIME: 'Sluttid',
  NEW_USER: 'Ny användare',
  NEW_USER_INFO:
    'Vill du ladda ner manualen och ge den till den nya användaren eller skapa kontot själv?',
  CREATE_NEW_USER: 'Skapa själv',
  CANCEL: 'Avbryt',
  DELETE_LAUNDRY_TIME: 'Ta bort tvättid',
  DELETE_LAUNDRY_TIME_INFO:
    'Är du säker på att du vill ta bort tvättiden? Detta kan inte göras ogjort.',
  YES: 'Ja',
  NO: 'Nej',
  MANANGE_LAUNDRY: {
    S: 'Hantera tvättstugor',
    M: 'Hantera tvättmaskiner'
  },
  NAME: 'Namn',
  OUT_OF_ORDER: 'Ur funktion',
  NEW_LAUNDRY: {
    S: 'Ny tvättstuga',
    M: 'Ny tvättmaskin'
  },
  DELETE_LAUNDRY: {
    S: 'Ta bort tvättstuga',
    M: 'Ta bort tvättmaskin'
  },
  DELETE_LAUNDRY_INFO: {
    S:
      'Är du säker på att du vill ta bort tvättstugan? Detta kan inte göras ogjort.',
    M:
      'Är du säker på att du vill ta bort tvättmaskinen? Detta kan inte göras ogjort.'
  }
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/LaundryTable/strings.js